import React from 'react';
import {Divider, Stack, Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {formatPriceBill} from 'presentation/utils';

import type {ChargeDetailsAccordionContentProps} from '../../types';
import {BillingBeneficiaryItem} from '../BillingBeneficiaryItem';
import {ChargeTotalStack} from './styles';

const {chargeDetailsAccordion} =
	translations['pt-br'].privateFlow.myFinancial.openBills.detailsDrawer;

function ChargeDetailsAccordionContent({
	billingBeneficiaries,
	totalValue,
	discountAmount,
	fineAmount,
	interestAmount,
	onInfoIconClick,
}: ChargeDetailsAccordionContentProps) {
	const isShowFine = fineAmount !== '0';
	const isShowDiscount = discountAmount !== '0';
	const isShowInterest = interestAmount !== '0';
	return (
		<Stack gap={1.5}>
			{billingBeneficiaries.map((item, index) => (
				<Stack key={`${item.nome}-${index}`} gap={1.5}>
					<BillingBeneficiaryItem
						item={item}
						coparticipationLabel={chargeDetailsAccordion.coparticipation}
						onInfoIconClick={onInfoIconClick}
					/>
					{index < billingBeneficiaries.length - 1 ? <Divider /> : null}
				</Stack>
			))}
			<Divider />
			<ChargeTotalStack gap={0}>
				{isShowInterest && (
					<Stack direction="row" justifyContent="space-between" alignItems="center">
						<Typography variant="body1">{chargeDetailsAccordion.interest}</Typography>
						<Typography variant="body1" color="error">
							+ {formatPriceBill(interestAmount)}
						</Typography>
					</Stack>
				)}
				{isShowFine && (
					<Stack direction="row" justifyContent="space-between" alignItems="center">
						<Typography variant="body1">{chargeDetailsAccordion.fine}</Typography>
						<Typography variant="body1" color="error">
							+ {formatPriceBill(fineAmount)}
						</Typography>
					</Stack>
				)}
				{isShowDiscount && (
					<Stack direction="row" justifyContent="space-between" alignItems="center">
						<Typography variant="body1">{chargeDetailsAccordion.discount}</Typography>
						<Typography variant="body1" color="success">
							- {formatPriceBill(discountAmount)}
						</Typography>
					</Stack>
				)}
				<Stack direction="row" justifyContent="space-between" alignItems="center">
					<Typography variant="body1">{chargeDetailsAccordion.totalToPayment}</Typography>
					<Typography variant="h6">{formatPriceBill(totalValue)}</Typography>
				</Stack>
			</ChargeTotalStack>
		</Stack>
	);
}

export {ChargeDetailsAccordionContent};
